import React, { useEffect, useState } from 'react';
import Grid from  '../grid/grid';
import GridLine from  '../grid-line/grid-line';
import './subcategory.scss';
import classNames from 'classnames';


const SubCategory = ({ h1, title, description, projects, html, video }) => {
  const worksData = projects?.join(',');
  
  const [isLoading, setIsLoading] = useState(worksData === '5018');
  
  useEffect(() => {
    if (!isLoading) return;
  
    let animationId;
  
    const applyChanges = () => {
      const el = document.querySelector('.p-v3-grid-item-id-5018');
  
      if (el) {
        if (!el.classList.contains('p-v5-grid-item-large')) {
          el.classList.add('p-v5-grid-item-large');
        }
        if (el.classList.contains('p-v5-grid-item-small')) {
          el.classList.remove('p-v5-grid-item-small');
        }
  
        const imagePath5018 = '/competencies/images/master-plan/yakutsk.png';
        const previewEl = el.querySelector('.p-v5-grid-item-preview');
  
        if (!previewEl.querySelector('.image')) {
          previewEl.innerHTML = `
            <div class="image">
              <img src="${imagePath5018}" class="">
            </div>
          `;
        }

        const titleOElement = el.querySelector('.p-v5-grid-item-title');

        if (titleOElement) {
          titleOElement.style.borderRadius = '0 0 4px 4px';
        }

        const itemOElement = el.querySelector('.p-v5-grid-item-o');

        if (itemOElement && !itemOElement.parentElement.classList.contains('p-v5-grid-item-title-descr-title')) {
          const wrapper = document.createElement('div');
          wrapper.className = 'p-v5-grid-item-title-descr-title';

          itemOElement.parentNode.replaceChild(wrapper, itemOElement);
          wrapper.appendChild(itemOElement);
        }
      }
    };
  
    const onResize = () => {
      console.log('onResize')
      applyChanges();
    };
  
    const onInit = () => {
      const el = document.querySelector('.p-v3-grid-item-id-5018');
  
      if (el?.classList.contains('p-v3-grid-item-inited')) {
        applyChanges();
        window.addEventListener('resize', onResize);
        console.log('onResize setted')
        setIsLoading(false);
      } else {
        animationId = requestAnimationFrame(onInit);
      }
    };
  
    animationId = requestAnimationFrame(onInit);
  
    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
      <React.Fragment>
        <div className="services-container">
          <div className="als-text-container">
            {h1 && <h1 className="services-container__header" dangerouslySetInnerHTML={{__html: h1}} />}
            {title && <h2 className="services-container__header" dangerouslySetInnerHTML={{__html: title}} />}
            {description && <p className="services__text"
               dangerouslySetInnerHTML={{__html: description}}
            />}
          </div>
          {projects && <div className={classNames("works-data", { loading: isLoading })} data-works-ids={projects.join(',')} />}
          {video && (
            <Grid>
              <GridLine>
                <div className="services-container__video">
                  <div>
                    <iframe width="100%" height="auto" src={video} frameBorder="0" allowFullScreen="" />
                  </div>
                </div>
              </GridLine>
            </Grid>
            )}
          {html && <div className="services__content" dangerouslySetInnerHTML={{ __html: html }} />}
        </div>
      </React.Fragment>
  );
}

export default SubCategory;
